import { ROUTE_PUSHED } from "./reducer";
import { AnyAction } from "redux";

export function pushRoute(nextUrl: string | null): AnyAction {
  return {
    type: ROUTE_PUSHED,
    payload: nextUrl,
  };
}
